import { useState } from 'react';
import { Grid } from '@material-ui/core';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Rating from '@material-ui/lab/Rating';
import "../Prestaciones/css/PrestacionCard.css";
import { MenuPrestacion } from "./MenuListPrestacion";
import GreenSwitch from "../ConfigPayroll/GreenSwitch";
import { useContext } from 'react';
import PrestacionContext from '../../context/PrestacionesContext/PrestacionContext';
import useUpdatePrestacionStatus from './hooks/useUpdatePrestacionStatus';
import ComentariosPrestacionModal from './modals/ComentariosPrestacionModal';

export const PrestacionInfoCard = ({ prestacion, paquetes = [] }: any) => {
  const { dispatch } = useContext(PrestacionContext);
  const [openComentarios, setOpenComentarios] = useState(false);
  const { updatePrestacionStatus, isUpdating } = useUpdatePrestacionStatus({
    activa: prestacion.Activa,
    paquetes,
    dispatch,
  });

  const truncateText = (text: string, maxLength: number) => {
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  };

  return (
    <Grid>
      <Card className='containerCardPrestacion'>
        <CardContent className='contedorGeneralPrestacion'>
          <div className='containerInfoimg'>
            <div className='containerImagenPrestacion'>
              <img src={prestacion.URL} alt="prestacion" className='imgPrestacion' />
            </div>
            <div className='containertipoPrestacion'>
              <span className='tipoPrestacion'>{prestacion.TipoPrestacion}</span>
            </div>
          </div>
          <div className='infoCardPrestacion' >
            <div className='superiorPrestacion'>
              <div className='containertitlePrestacion'>
                <span className={prestacion.Titulo.length <= 30 ? 'titlePrestacionCard' : 'titlePrestacionCardMin'}>{prestacion.Titulo}</span>
              </div>
              <div className='infoCardControllers'>
                <div className='switchPrestacion' style={{ position: 'relative' }}>
                  <span className='actPrestacion'>{prestacion.Activa === true ? 'Activo' : prestacion.Activa === false ? 'Inactivo' : prestacion.Activa}</span>
                  <div className='switchPrestacion'>
                    <GreenSwitch updatePayrollStatus={updatePrestacionStatus}
                      id={prestacion.id}
                      status={prestacion.Activa}
                      disabled={isUpdating}
                    />
                  </div>
                </div>
                <div className='crudPrestacion'>
                  <MenuPrestacion
                    id={prestacion.id}
                    paquetes={paquetes}
                  />
                </div>
              </div>
            </div>
            <div className={prestacion.Descripcion.length <= 300 ? 'containerDescripcionPrestacion' : 'containerDescripcionPrestacionMin'}>
              <span className='descripcionPrestacion'>{truncateText(prestacion.Descripcion, 120)}</span>
            </div>

            <div className='countersPrestacion'>
              <div className="containerPrestacion">
                <span className='countPrestacion'>{prestacion.countColaboradores}</span>
                <span className='meensajePrestacion'>Colaboradores</span>
              </div>
              <div className="pv-line"></div>
              <div className="containerPrestacion">
                <span className='countPrestacion'>{prestacion.countRestricciones}</span>
                <span className='meensajePrestacion'>Restricciones</span>
              </div>
              <div className="pv-line"></div>
              <div
                className="containerPrestacion"
                onClick={() => prestacion.countComentarios > 0 && setOpenComentarios(true)}
                style={{ cursor: prestacion.countComentarios > 0 ? 'pointer' : 'default' }}
                title={prestacion.countComentarios > 0 ? 'Ver comentarios' : undefined}
              >
                <span className='countPrestacion'>{prestacion.countComentarios}</span>
                <span className='meensajePrestacion'>Comentarios</span>
              </div>
            </div>

            {openComentarios && (
              <ComentariosPrestacionModal
                open={openComentarios}
                onClose={() => setOpenComentarios(false)}
                idPrestacion={prestacion.id}
                tituloPrestacion={prestacion.Titulo}
              />
            )}
            {prestacion.promedio > 0 &&
              <div className='star'>
                <Rating name="half-rating-read" defaultValue={prestacion.promedio} precision={0.5} readOnly />
              </div>
            }
          </div>
        </CardContent>
      </Card>
    </Grid>
  )
}